import { TitleCasePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { User } from 'src/app/component/auth/model/user.model';
import { City } from 'src/app/component/common-components/location/model/city.model';
import { Country } from 'src/app/component/common-components/location/model/country.model';
import { PostalAddresses } from 'src/app/component/party/model/postal-addresses.model';
import { UserProfileService } from 'src/app/component/user-profile/service/user-profile.service';
import { Student } from 'src/app/model/student/student.model';
import { SimpleDatePipe } from 'src/app/pipes/simple-date.pipe';
import { PreferredInfo } from '../../../model/preferred-info.model';
import { StudentHelperService } from '../../../service/student-helper.service';
import { StudentService } from '../../../service/student.service';
import { State } from 'src/app/component/common-components/location/model/state.model';
import { StudentHelper2Service } from '../../../service/student-helper2.service';

@Component({
    selector: 'view-child-demographic-general',
    templateUrl: './view-child-demographic-general.component.html',
    styleUrl: './view-child-demographic-general.component.scss'
})
export class ViewChildDemographicGeneralComponent implements OnInit {
    @Input() studentId!: number;
    @Input() studentHelperNumber: number = 1;

    student: Student;
    user: User;

    birthCity: City;
    birthState: State;
    birthCountry: Country;
    birthAddress: PostalAddresses;
    preferredInfo: PreferredInfo;

    isLoading: boolean = false;

    simpleDatePipe: SimpleDatePipe = new SimpleDatePipe();

    promises: Array<any> = [];

    constructor(
        private studentService: StudentService,
        private titlecasePipe: TitleCasePipe,
        private userProfileService: UserProfileService,
        private studentHelperService: StudentHelperService,
        private studentHelper2Service: StudentHelper2Service
    ) {}

    ngOnInit(): void {
        this.init();
    }

    init() {
        this.isLoading = true;

        this.show();
        this.getBirthAddress();
        this.getPreferredInfo();
        this.getUserProfile();
        Promise.all(this.promises).then((res) => {
            this.isLoading = false;
        });
    }

    show() {
        let deferred = new Promise((resolve, reject) => {
            this.studentService.show(this.studentId).subscribe((res) => {
                if (res.student) {
                    this.student = res.student;

                    if (this.studentHelperNumber === 1) {
                        this.studentHelperService.setStudent(this.student);
                        this.studentHelperService.setStudentName(this.getStudentName(this.student));
                        this.studentHelperService.setMsdNumber(this.student.MSD_NUMBER!);
                        this.studentHelperService.setMerged(this.student.DUPLICATE_DEACTIVATE && this.student.DUPLICATE_DEACTIVATE > 0 ? 'Merged' : '');
                        this.studentHelperService.setIsMerged(this.student.IS_MERGED ? true : false);
                    } else {
                        this.studentHelper2Service.setStudent(this.student);
                        this.studentHelper2Service.setStudentName(this.getStudentName(this.student));
                        this.studentHelper2Service.setMsdNumber(this.student.MSD_NUMBER!);
                        this.studentHelper2Service.setMerged(this.student.DUPLICATE_DEACTIVATE && this.student.DUPLICATE_DEACTIVATE > 0 ? 'Merged' : '');
                        this.studentHelper2Service.setIsMerged(this.student.IS_MERGED ? true : false);
                    }

                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    getBirthAddress() {
        let deferred = new Promise((resolve, reject) => {
            this.studentService.getStudentBirthAddress(this.studentId).subscribe((res) => {
                if (res.birthAddress) {
                    this.birthAddress = res.birthAddress;

                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    getPreferredInfo() {
        let deferred = new Promise((resolve, reject) => {
            this.studentService.getPreferredInfo(this.studentId).subscribe((res) => {
                if (res.preferredInfo) {
                    this.preferredInfo = res.preferredInfo;

                    resolve(res);
                } else if (res?.msg) {
                    this.preferredInfo = new PreferredInfo();
                    resolve(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    getUserProfile() {
        let deferred = new Promise((resolve, reject) => {
            this.userProfileService.getMyProfile().subscribe((res) => {
                if (res?.user) {
                    this.user = res.user;

                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });
        this.promises.push(deferred);
    }

    getStudentName(student: Student) {
        let name: string = '';
        name += student.PERSON.LAST_NAME;
        name += student.SECOND_LAST_NAME ? ' ' + student.SECOND_LAST_NAME : '';
        name += ', ' + student.PERSON.FIRST_NAME;
        name += student.PERSON.MIDDLE_INITIAL ? ' ' + student.PERSON.MIDDLE_INITIAL : '';

        name = this.titlecasePipe.transform(name);
        return name;
    }
}
